import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// EXCEL ATTENDANCE VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify Excel Attendance Inbox (GET)
export const getVerifyExcelAttendance = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            RoleID: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyExcelAttendance?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Excel Attendance Details (POST)
export const getExcelAttendance = async (payload) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!payload.AttendanceId) {
            throw new Error('AttendanceId is required');
        }
        if (!payload.RoleId) {
            throw new Error('RoleId is required');
        }
        
        // Build the complete payload
        const requestPayload = {
            CostCenter: payload.CostCenter || '',
            GenerateFor: payload.GenerateFor || 'Month',
            AttendanceDate: payload.AttendanceDate || '',
            MonthName: payload.MonthName || '',
            Year: payload.Year || '',
            ExcelRefno: payload.ExcelRefno || '',
            AttendanceId: payload.AttendanceId?.toString() || '',
            TransactionNo: payload.TransactionNo || '',
            CCName: payload.CCName || '',
            LabourType: payload.LabourType || '',
            ContractorCode: payload.ContractorCode || '',
            ContractorName: payload.ContractorName || '',
            RoleId: payload.RoleId?.toString() || '' // Add RoleId to payload if needed
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetExcelAttendance`,
            requestPayload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve Excel Month Attendance (PUT)
export const approveExcelMonthAttendance = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.AttendanceJson) {
            throw new Error('AttendanceJson is required');
        }
        if (!params.CostCenter) {
            throw new Error('CostCenter is required');
        }
        if (!params.GenerateFor) {
            throw new Error('GenerateFor is required');
        }
        if (!params.RoleId) {
            throw new Error('RoleId is required');
        }
        if (!params.Createdby) {
            throw new Error('Createdby is required');
        }
        if (!params.Remarks) {
            throw new Error('Remarks is required');
        }
        if (!params.ExcelRefno) {
            throw new Error('ExcelRefno is required');
        }
        if (!params.LabourType) {
            throw new Error('LabourType is required');
        }
        // ContractorCode is NOT mandatory - only required if LabourType is not "Own Labour"
        
        const payload = {
            AttendanceJson: params.AttendanceJson, 
            CostCenter: params.CostCenter.toString().trim(), 
            GenerateFor: params.GenerateFor.toString().trim(), 
            RoleId: parseInt(params.RoleId), // 
            Createdby: params.Createdby.toString().trim(), 
            Remarks: params.Remarks.toString().trim(), 
            ExcelRefno: params.ExcelRefno.toString().trim(),
            LabourType: params.LabourType.toString().trim(), 
            ContractorCode: params.ContractorCode?.toString().trim() || ''
        };
        
         // DEBUG
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveExcelMonthAttendance`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};